<template>
  <el-container>
    <el-header class="table-header">
      <router-link :to="{name: 'menuAdd', params: {tree:treeData}}">
          <el-button type="primary" size="small">{{$t('common.Add')}}</el-button>
      </router-link>
        <el-button icon="el-icon-search" @click="search(form)" size="small">{{$t('common.Search')}}</el-button>
        <el-button icon="el-icon-refresh-left" @click="reset" size="small">{{$t('common.Reset')}}</el-button>
    </el-header>
    <el-container>
      <el-aside style="width: 200px;" class="aSide">
        <el-tree
          :data="treeData"
          :props="{children: 'children',label: 'label',id: 'id'}"
          :expand-on-click-node="false"
          ref="tree"
          node-key="id"
          :empty-text="$t('common.NoData')"
          @node-click="handleNodeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
                <!--<i :class="111"></i>{{ node.label }}-->
              <img :src="menuFile">{{ node.label }}
            </span>
          </span>
        </el-tree>
      </el-aside>
      <el-main class="table-main">
        <el-form :model="form" label-width="80px" class="table-form" size="mini">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('base.info.menu.MenuNameCn')">
                <el-input v-model.trim="form.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('common.Type')">
                <el-select v-model.trim="form.type">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('base.info.menu.ParentName')">
                <el-input v-model.trim="form.parentNameCn"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="tableData"
          border stripe
          max-height="450"
          style="width: 100%">
          <el-table-column
            type="index">
          </el-table-column>
          <!--<el-table-column prop="systemId" :label="$t('base.info.menu.SystemId')" align="center" v-if="false" width="100">
          </el-table-column>-->
          <el-table-column
            prop="systemName"
            :label="$t('base.info.menu.SystemName')"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="code"
            :label="$t('base.info.menu.MenuCode')"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="nameCn"
            :label="$t('base.info.menu.MenuNameCn')"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="nameEn"
            :label="$t('base.info.menu.MenuNameEn')"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('common.Type')"
            align="center"
            width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.type==='1'" size="small">{{$t('base.info.menu.Default')}}</span>
              <span v-if="scope.row.type==='D'" size="small">{{$t('base.info.menu.Catalog')}}</span>
              <span v-if="scope.row.type==='U'" size="small">{{$t('base.info.menu.Link')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('common.Status')"
            width="100"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status===50" size="small">{{$t('common.Normal')}}</span>
              <span v-if="scope.row.status===40" size="small">{{$t('common.Disable')}}</span>
              <span v-if="scope.row.status===10" size="small">{{$t('common.Draft')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('common.Remark')"
            width="120"
            align="center">
          </el-table-column>
          <el-table-column
            prop="parentId"
            label="上级Id"
            align="center"
            width="100" v-if="false" >
          </el-table-column>
          <el-table-column
            prop="parentNameCn"
            :label="$t('base.info.menu.ParentName')"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="asp"
            :label="$t('base.info.menu.Asp')"
            width="100"
            align="center">
          </el-table-column>
          <el-table-column
            fixed="right"
            width="120"
            align="center"
            :label="$t('common.Operate')">
            <template slot-scope="scope">
              <router-link :to="{name: 'menuEdit', params: {row:scope.row}}">
                <el-button size="mini" type="text">{{$t('common.Edit')}}</el-button>
              </router-link>
              <el-button type="text" size="mini" @click="deleteRow(scope.row)">{{$t('common.Delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

export default {
  data () {
    return {
      menuFile: './static/images/menuFile.png',
      treeData: [],
      tableData: [],
      form: {},
      row: '',
      optionsSys: [],
      value: '',
      data: {id: '', systemId: ''}
    }
  },
  methods: {
    handleNodeClick (data) {
      this.data = data
      this.$api.menuList.menufindById(this.qs.stringify({id: this.data.id, systemId: this.data.systemId}))
        .then((response) => {
          this.tableData = response.data.data
        }).catch((error) => {
          console.log(error)
        })
    },
    deleteRow (data) {
      this.$confirm(this.$t('common.DeleteConfirm'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.menuList.menuDelete(this.qs.stringify({id: data.id}))
          .then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
            this.search(this.form)
            this.convert()
          }).catch((error) => {
            console.log(error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.Cancel')
        })
      })
    },
    search (data) {
      let param = {data: {id: this.data.id, systemId: this.data.systemId, name: data.name, type: data.type, parentNameCn: data.parentNameCn}}
      this.$api.menuList.menufindByCondition(param).then((response) => {
        this.tableData = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    reset () {
      this.form = {}
    },
    convert () {
      this.$api.menuList.findAllMenu().then((response) => {
        this.treeData = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  created () {
    this.convert()
  },
  computed: {
    options () {
      let arry = []
      arry.push({'value': '', 'label': this.$t('common.PleaseChoose')})
      arry.push({'value': 'D', 'label': this.$t('base.info.menu.Catalog')})
      arry.push({'value': 'U', 'label': this.$t('base.info.menu.Link')})
      return arry
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/menuList.vue